import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';

import {
  NetworkGraphV2Component
} from '@components/charts/network-graph-v2/network-graph-v2.component';
import { AnalyzeService } from '@services/analyze.service';
import _ from 'lodash';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-graph-wrapper',
  standalone: true,
  imports: [NetworkGraphV2Component],
  templateUrl: './graph-wrapper.component.html',
  styleUrls: ['./graph-wrapper.component.scss'],
})
export class GraphWrapperComponent implements OnInit {
  data: any;
  @Input() defaultView: string;
  @Input() resize: string;
  private ngxEventBus: any[] = [];
  private readonly destroyRef = inject(DestroyRef);

  constructor(
      private analyzeService: AnalyzeService,
  ) { }
  ngOnInit(): void {
    this.analyzeService.getAnalyzeData()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        // added a timeout to detect change in data for network graph
        this.data = undefined;
        setTimeout(() => {
          this.init(_.cloneDeep(res));
        }, 10);
      });
  }

  init(data) {
    const isGridDrilling = !this.analyzeService.getGridDrillingMode();
    if (data && data.nodes && isGridDrilling) {
      if (data.nodes?.length > 250) {
        return;
      }
      this.data = {
        type: 'network-graph',
        ppmLayer: this.analyzeService.getLayer(),
        data
      };
    }
  }
}
